<template>
  <div class="container">
    <div class="card">
      <!--<img src="..." class="card-img-top" alt="...">-->
      <div class="card-body" v-for="(dato, index) in miauto" :key="index">
        <form class="text-left">
          <div class="form-group">
            <p class="etiquetaLabel text-center">
              {{ dato.patente }} - {{ dato.marca | mayuscula }}
            </p>
            <p class="etiqueta text-center">
              {{ dato.nombre }} - {{ dato.residente }}
            </p>
          </div>
          <div class="form-group">
            <label class="etiquetaLabel" for="numerodepartamento">Depto</label>
            <input
              id="numerodepartamento"
              type="number"
              class="etiqueta"
              v-model.number="numerodepartamento"
              min="1001"
              max="2209"
              size="30"
            />
          </div>
          <div class="form-group">
            <label class="etiquetaLabel" for="puesto"
              >Puesto ({{ traerdatapuestos.length }}) </label
            ><br />
            <select v-model="numeropuesto" class="etiqueta">
              <option
                v-for="(item, index) in traerdatapuestos"
                v-bind:value="item.text"
                :key="index"
              >
                {{ item.value }}
              </option>
            </select>
          </div>

          <!--<div class="form-group">
                        <label class='etiquetaLabel' for="puesto">Puesto</label>
                        <input id='puesto' type="number" class="etiqueta" v-model.number="numeropuesto" min="1" max="46" size="2">           
                    </div>-->

          <div class="my-5">
            <button
              type="button"
              class="btn btn-primary btn-block my-3 "
              @click.prevent="
                parking();
                mipuesto();
              "
            >
              Parking
            </button>
            <button
              type="button"
              class="btn btn-secondary btn-block my-3"
              @click.prevent="volver"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "CarParking",
  data() {
    return {
      miauto: {},
      patente: "",
      residente: "",
      nombre: "",
      numerodepartamento: "",
      marca: "",
      numeropuesto: "",
      disponible: true,
      idDocPuesto: "",
    };
  },
  computed: {
    traerdatapuestos() {
      return this.$store.getters.enviardatapuestos.filter((datos) => {
        return datos.disponible === true;
      });
    },
  },
  mounted() {
    this.patente = this.$route.params.id;
    this.miauto = this.$store.getters.enviardataautos.filter((datos) => {
      return datos.patente.includes(this.$route.params.id.toUpperCase());
    });
    this.numerodepartamento = this.miauto[0].numerodepartamento;
    this.nombre = this.miauto[0].nombre;
    this.residente = this.miauto[0].residente;
  },
  methods: {
    volver() {
      this.$router.push("/");
    },
    parking() {
      if (!this.numeropuesto && !this.numerodepartamento) {
        Swal.fire("Depto y Puesto");
      } else {
        let auxiliar = {
          aparcado: true,
          fechaing: new Date(),
          fechasal: new Date(), //https://www.epochconverter.com/  Esta url convierte timestamp en human date visual
          numeropuesto: parseInt(this.numeropuesto),
          numerodepartamento: this.numerodepartamento,
          residente: this.residente,
          nombre: this.nombre.toUpperCase(),
          patente: this.patente.toUpperCase(),
        };
        this.$store.dispatch("saveParking", auxiliar);
      }
    },
    mipuesto() {
      this.$store.dispatch("puestoDisponibilidad", this.numeropuesto);
      this.$router.push("/");
    },
  },

  // const fechaing = moment();
  //const fechasal = fechaing.clone().add(8, "hours");

  //console.log(moment(fechaing).format("LLL"));
  //console.log(moment(fechasal).format("LLL"));
};
</script>

<style></style>
